<mat-toolbar class="toolbar">
  <span class="title">Connexion</span>
  <span class="sp"></span>
  <a mat-button routerLink="/register">
    <mat-icon fontSet="material-symbols-outlined">person_add</mat-icon>
    Create an account
  </a>
</mat-toolbar>

<div class="auth-wrap">
  <mat-card class="auth-card">
    <mat-card-header>
      <mat-card-title>Welcome</mat-card-title>
      <mat-card-subtitle>Connect to <b>flight booking</b></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
        <mat-form-field appearance="fill" class="ff-normal-16">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" autocomplete="username" />
          <mat-icon matSuffix fontSet="material-symbols-outlined">person</mat-icon>
          <mat-error *ngIf="form.get('username')?.hasError('required')">Username required</mat-error>
          <!-- <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            autocomplete="email"
          />
          <mat-icon matSuffix fontSet="material-symbols-outlined"
            >mail</mat-icon
          >
          <mat-error *ngIf="form.get('email')?.hasError('required')"
            >Email requis</mat-error
          >
          <mat-error *ngIf="form.get('email')?.hasError('email')"
            >Format invalide</mat-error
          > -->
        </mat-form-field>

        <mat-form-field appearance="fill" class="ff-normal-16">
          <mat-label>Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" autocomplete="current-password" />
          <button
            mat-icon-button
            type="button"
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="hide ? 'Afficher le mot de passe' : 'Masquer le mot de passe'"
            [attr.aria-pressed]="!hide"
          >
            <mat-icon fontSet="material-symbols-outlined">{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('password')?.hasError('required')">Password required</mat-error>
          <mat-hint align="end">
            <a class="link" routerLink="/reset-password">Password forgotten&nbsp;?</a>
          </mat-hint>
        </mat-form-field>

        <button mat-flat-button color="primary" class="submit" type="submit" [disabled]="form.invalid || loading">
          <mat-icon fontSet="material-symbols-outlined">login</mat-icon>
          Login
        </button>

        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

        <mat-error *ngIf="error" class="server-error">{{ error }}</mat-error>
      </form>
    </mat-card-content>

    <mat-card-actions align="end">
      <span class="muted">No account&nbsp;?</span>
      <a mat-stroked-button color="primary" routerLink="/register">
        <mat-icon fontSet="material-symbols-outlined">person_add</mat-icon>
        Create an account
      </a>
    </mat-card-actions>
  </mat-card>
</div>
